// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__3FU7Z","auth":"modal_auth__I+evp","change_password":"modal_change_password__3jANi","btns":"modal_btns__lGKQt"};